import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../../doorstepServices/DoorstepServices.css"
import { IWorkerRatings } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Paginator from "src/components/layout/Paginator";
import { useParams } from "react-router-dom";
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg";
import moment from "moment";
import { getWorkerRatings } from "../../workers/Workers";
import { formatDiffrentDate } from "src/utils/normalFuntions";
import StarRating from "src/components/layout/StarRating";
import LoadingGif from "src/components/layout/Loader";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";

interface IService {
   _id: string; // Unique identifier
   description: string[]; // List of service descriptions
   category_name: string; // Category name (e.g., "Plumbing Services", "Engineer")
   service_title: string; // Title of the service
   service_image: string; // URL of the service image
   price?: number; // Price (unique to one object)
   price_per_hour?: number; // Price per hour (common but optional)
   price_per_half_hour?: number; // Price per half-hour (unique to one object)
   about: string; // Service details or description
   createdAt: string; // Creation timestamp
   updatedAt: string; // Last update timestamp
   __v: number; // Version key
   service_providers: string[]; // List of service providers (e.g., "Plumber")
   service_type: string; // Type of service (e.g., "normal_worker", "professional_worker")
   is_deleted: boolean; // Deletion status
   doorstop_category_id?: string; // Doorstep category ID (unique to one object)
   worker_category_id?: string; // Worker category ID (unique to one object)
   worker_type?: string; // Worker type (e.g., "engineer", unique to one object)
   working_basis?: string; // Basis of work (e.g., "hour", unique to one object)
   is_count?: boolean; // Whether counting is applicable (unique to one object)
   hours_count?: number; // Number of hours (unique to one object)
   advance_booking?: boolean; // Whether advance booking is required (unique to one object)
}


export const getServiceById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-service/${id}`, {
      headers: {
         "x-access-token": token
      }

   })
};



const DoorstepServiceDetailsPage = () => {

   const { id } = useParams();

   const Token = Cookies.get("token");
   const dispatch = useAppDispatch();
   const [selectedService, setSelectedService] = useState<IService>();
   const [PaginatedData, setPaginatedData] = useState({
      pageNo: 1,
      pageSize: 10,
      totalPages: 0
   });
   const loading = useAppSelector(state => state.loading.value);
   const [ratingsArray, setRatingsArray] = useState<IWorkerRatings[]>([]);
   const [averageRating, setAverageRating] = useState(0);

   useEffect(() => {
      dispatch(startLoading());
      getServiceById(Token as string, id as string).then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            console.log(res?.data)
            setSelectedService(res?.data?.data);
         } else {
            Swal.fire({
               icon: "error",
               title: "Oops...",
               text: `${res?.data?.data?.msg}`,

            });
         }
      })
         .catch((err) => {
            console.log(err)
            throw err;
         })
         .finally(() => {
            dispatch(stopLoading());
         })
   }, [id])

   useEffect(() => {

      const params = {
         token: Token as string,
         id: id as string,
         pageNo: PaginatedData?.pageNo,
         pageSize: PaginatedData?.pageSize,
         type: "service",
      };
      getWorkerRatings(params).then((res) => {

         if (res?.data?.status_code === 200) {

            setRatingsArray(res?.data?.data?.results);
            setPaginatedData({
               ...PaginatedData,
               totalPages: res?.data?.data?.totalPages
            });
            setAverageRating(res?.data?.data?.averageRating);
         }
      })
         .catch((err: any) => {
            console.log(err)
         })
   }, [id, PaginatedData?.pageNo, PaginatedData?.pageSize])

   const istDate = moment(selectedService?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');
   useEffect(() => {
      console.log(selectedService?.working_basis);
   }, [selectedService])
   return (
      <MainLayout showAllFilters={true}>

         <div className="main-div">

            <div className={`category-main me-2 p-3 p-md-4 `} >
               <div className="row">

                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">

                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    <img
                                       src={
                                          selectedService?.service_image
                                             ? typeof selectedService?.service_image === 'string'
                                                ? selectedService?.service_image
                                                : URL.createObjectURL(selectedService?.service_image)
                                             : profileIcon
                                       }

                                    />
                                 </div>
                                 <div className="d-flex flex-column">
                                    <h5 className="mb-1 text-start">{selectedService?.service_title ?? "NA"} </h5>
                                    <span className="text-start  mb-1">{selectedService?.category_name ?? "NA"}</span>
                                    <span className="text-start">Created At: {istDate ?? "NA"} </span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Service Detials</h5>
                              <dl className="row mb-0">
                                 {/* Worker Type */}
                                 <dt className="col-4 fw-medium text-dark mb-3">Service Id</dt>
                                 <dd className="col-8 mb-3"> {selectedService?._id ?? 0}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3">Service Title</dt>
                                 <dd className="col-8 mb-3"> {selectedService?.service_title ?? 0}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3">Category Name</dt>
                                 <dd className="col-8 mb-3"> {selectedService?.category_name ?? "NA"} </dd>
                                 {
                                    (selectedService?.service_type === 'professional_worker') ?
                                       <>
                                          <dt className="col-4 fw-medium text-dark mb-3"> Price</dt>
                                          <dd className="col-8 mb-3"> &#8377;{selectedService?.price ?? 0}</dd>


                                       </> :

                                       <>
                                          <dt className="col-4 fw-medium text-dark mb-3">Hourly Price</dt>
                                          <dd className="col-8 mb-3"> &#8377;{selectedService?.price_per_hour ?? 0}</dd>
                                          <dt className="col-4 fw-medium text-dark mb-3">Half Hourly Price</dt>
                                          <dd className="col-8 mb-3"> &#8377;{selectedService?.price_per_half_hour ?? 0}</dd>
                                          <dt className="col-4 fw-medium text-dark mb-3">Service Provides </dt>
                                          <dd className="col-8 mb-3"> {selectedService?.service_providers?.join(", ") ?? 0}</dd>
                                       </>
                                 }
                                 {
                                    (selectedService?.working_basis === "hour" && selectedService?.hours_count !== 1) ?
                                       <>
                                          <dt className="col-4 fw-medium text-dark mb-3">Hourly Price</dt>
                                          <dd className="col-8 mb-3"> &#8377;{selectedService?.price_per_hour ?? 0}</dd>
                                          {/* <dt className="col-4 fw-medium text-dark mb-3">Half Hourly Price</dt>
                                          <dd className="col-8 mb-3"> &#8377;{selectedService?.price_per_half_hour ?? 0}</dd> */}
                                       </> : ""
                                 }



                                 <dt className="col-4 fw-medium text-dark mb-3">Description </dt>
                                 <dd className="col-8 mb-3"> {selectedService?.description?.join(", ") ?? 0}</dd>

                              </dl>
                           </div>
                        </div>

                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">
                     <div className="row ">
                        <div className="col-md-12 p-2">
                           <div className="card">
                              <div className="card-header d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                 <h5 className="text-start mb-0" >
                                    Ratings on Service
                                 </h5>
                                 <div className="d-flex gap-2">
                                    <h6>
                                       Average Ratings:
                                    </h6>
                                    <strong className="d-flex align-items-center">
                                       {averageRating}
                                    </strong>
                                 </div>

                              </div>
                              <div className="card-body">
                                 <div className="border rounded p-3 pb-0 transaction-body" >
                                    <div className="table-responsive">
                                       <table className="table  card-body">
                                          <thead>
                                             <tr className="transaction-tr">
                                                <th scope="col" className="text-start ps-4">Sr.No.</th>
                                                <th scope="col" className="text-start ps-4">Ratings</th>
                                                <th scope="col" className="text-start ps-4">Rating Type</th>
                                                <th scope="col" className="text-start ps-4">Review</th>
                                                <th scope="col" className="text-start ps-4">User Name</th>
                                                <th scope="col" className="text-start ps-4">User Phone</th>
                                                <th scope="col" className="text-start ps-4">Service Name</th>
                                                {/* <th scope="col" className="text-start ps-4"></th> */}

                                                <th scope="col" className="text-start ps-4">Published At</th>

                                             </tr>

                                          </thead>
                                          <tbody>
                                             {
                                                ratingsArray && ratingsArray?.map((data, i) => {
                                                   // const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                   const createdAt = formatDiffrentDate(data?.createdAt);
                                                   const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);

                                                   const dotData = data?.comment
                                                      ?.slice(0, 40) + (data?.comment.length > 40 ? " ..." : "");

                                                   return (
                                                      <>
                                                         <tr key={data?._id}>
                                                            <td className="text-start align-content-center ps-4">
                                                               <span className="">
                                                                  {rowNumber}
                                                               </span>

                                                            </td>
                                                            <td className="text-start align-content-center ps-4">
                                                               <StarRating averageRating={data?.rating} />
                                                            </td >
                                                            <td className="text-start align-content-center ps-4">
                                                               {data?.rating_type === "professionalServiceRatings" || data?.rating_type === "doorStepRatings" ? "Service Rating" : "Worker Rating"}
                                                            </td >

                                                            <td className="text-start align-content-center ps-4" title={data?.comment} style={{ cursor: "pointer" }}>
                                                               {dotData}
                                                            </td >

                                                            <td className="text-start align-content-center ps-4" >

                                                               {data?.user_name}
                                                            </td>
                                                            <td className="text-start align-content-center ps-4">
                                                               {data?.user_phone}

                                                            </td>

                                                            <td className="text-start align-content-center ps-4 ">

                                                               {data?.rating_type === "normal" ? "None" : data?.service_title}
                                                            </td>

                                                            <td className="icon-td align-content-center text-start ps-4" >
                                                               {createdAt?.formattedDate}
                                                            </td>
                                                         </tr >

                                                      </>


                                                   )
                                                }
                                                )
                                             }

                                          </tbody>
                                       </table>
                                       {
                                          loading ? <LoadingGif /> : ""
                                       }
                                    </div>
                                    <Paginator
                                       totalPages={PaginatedData?.totalPages}
                                       pageNo={PaginatedData?.pageNo}
                                       onPageChange={(e, no) => setPaginatedData({
                                          ...PaginatedData,
                                          pageNo: no

                                       })}
                                       alignment="right"
                                    />
                                 </div>

                              </div>

                           </div>
                        </div>


                     </div>
                  </div>

               </div>
            </div>

         </div>

      </MainLayout>
   )

};



export default DoorstepServiceDetailsPage;